import React from 'react';
import { MailTemplateSubtype, MailTemplateType } from 'helper/mailer';
import {
  Col, Form, Row,
} from 'react-bootstrap';
import useTemplateForm from 'utils/hooks/mailer/useTemplateForm';
import AlertsCollection from 'components/AlertsCollection';
import TextArea from 'components/DesignSystem/TextArea';
import Selector from 'components/DesignSystem/Selector';
import Button from 'components/DesignSystem/Button';
import TemplateInstructions from './Instructions';

import './index.scss';

export default function TemplateForm({
  types,
  typesLoading,
  templateType = null,
  templateSubtype = null,
}: {
  types: MailTemplateType[] | undefined,
  typesLoading: boolean,
  templateType?: MailTemplateType | null,
  templateSubtype?: MailTemplateSubtype | null,
}) {
  const {
    id: templateTypeId,
    subtypeName,
    setSubtypeName,
    subject,
    setSubject,
    template: templateBody,
    setTemplate: setTemplateBody,
    submitDisabled,
    onSubmit,
    onClear,
    handleChange,
    handleTypeSelectChange,
    saveLoading,
    validated,
    alerts,
  } = useTemplateForm(templateType, templateSubtype, types);

  return (
    <div className="mt-3 pb-3">
      <Row>
        <Col>
          <AlertsCollection alerts={alerts} />
        </Col>
      </Row>
      <Form
        className="template-form"
        noValidate
        validated={validated}
      >
        <fieldset disabled={saveLoading || typesLoading}>
          <Row>
            <Col md={6}>
              <Selector
                label="Tipo"
                value={templateTypeId}
                setValue={handleTypeSelectChange}
                error={validated && !templateTypeId ? 'Selecione o tipo' : undefined}
              >
                {typesLoading && <option value="" label="Carregando..." />}
                {types?.map((type) => (
                  <option key={type.id} value={type.id}>{type.label}</option>
                ))}
              </Selector>
              <input type="hidden" name="templateType" value={templateTypeId} />
            </Col>
            <Col md={6}>
              <Form.Group controlId="templateSubtype">
                <Form.Label style={{ marginBottom: 0 }}>Subtipo</Form.Label>
                <Form.Control
                  type="text"
                  name="templateSubtype"
                  value={subtypeName}
                  onChange={handleChange(setSubtypeName)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Não deixe o subtipo em branco
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-2">
            <Form.Group controlId="templateSubject">
              <Form.Label>Assunto</Form.Label>
              <Form.Control
                type="text"
                name="templateSubject"
                value={subject}
                onChange={handleChange(setSubject)}
                required
              />
              <Form.Control.Feedback type="invalid">
                Não deixe o assunto em branco
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mt-2">
            <TextArea
              label="Corpo"
              controlId="templateBody"
              name="templateBody"
              value={templateBody}
              onChange={handleChange(setTemplateBody)}
              rows={8}
              required
              error="Não deixe o corpo em branco"
            />
          </Row>
          <div className="d-flex flex-row mt-4">
            <Button
              type="secondary"
              onClick={onClear}
              className="me-2"
            >
              Limpar
            </Button>
            <Button
              disabled={submitDisabled}
              onClick={onSubmit}
            >
              Enviar
            </Button>
          </div>
        </fieldset>
      </Form>
      <hr />
      <TemplateInstructions />
    </div>
  );
}
